import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import upiQr from '../images/upi-qr.jpeg';
import { useAuth } from '../context/AuthContext';
import Seo from '../components/Seo';
import PriceTag from '../components/PriceTag';

// id doubles as the /card-pricing cardKey suffix (`micro-${id}`) and as the
// default shown until admin overrides load.
export const MICRO_COURSES = [
  {
    id: 1,
    title: "Frontend Web Development",
    desc: "Build real projects using HTML, CSS and JavaScript — structured across 4 modules with a final project.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 2,
    title: "Backend Node.js Development",
    desc: "Create a secure REST API with Express, MongoDB, and JWT authentication — across 4 modules with a final project.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 3,
    title: "MERN Stack Development",
    desc: "Build a complete MongoDB, Express, React and Node.js blog platform with authentication — across 4 modules.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 4,
    title: "UI/UX Design",
    desc: "Design a complete, high-fidelity Figma prototype from wireframes to a final walkthrough — across 4 modules.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 5,
    title: "Python Data Science",
    desc: "Analyze real datasets, visualize insights, and train your first ML model — across 4 modules with a final project.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 6,
    title: "Python Programming",
    desc: "Go from Python basics to a complete command-line Expense Tracker — across 4 modules with a final project.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 7,
    title: "Java Full Stack Development",
    desc: "Build a secure, full stack Employee Management System with Spring Boot and a React/Thymeleaf frontend.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 8,
    title: "Cloud Development",
    desc: "Launch EC2 instances, host on S3, and deploy a full application live to the cloud — hands-on AWS from day one.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 9,
    title: "Mobile App Development",
    desc: "Build a cross-platform React Native app — navigation, APIs, native device features, and a final published-ready project.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: 10,
    title: "DevOps",
    desc: "Go from Git workflows to a full CI/CD pipeline — Docker, GitHub Actions, and automated deployment to a live app.",
    defaultPrice: 99,
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop"
  }
];








const DecorativeBubbles = () => (
  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
    
    <div style={{ position: 'absolute', top: '20%', left: '-40px', width: '120px', height: '120px', borderRadius: '50%', background: 'var(--v1)', opacity: 0.15 }} />
    <div style={{ position: 'absolute', top: '35%', left: '40px', width: '40px', height: '40px', borderRadius: '50%', border: '3px solid var(--v2)', opacity: 0.25 }} />
    <div style={{ position: 'absolute', top: '10%', left: '80px', width: '20px', height: '20px', borderRadius: '50%', background: 'var(--v1)', opacity: 0.2 }} />
    <div style={{ position: 'absolute', bottom: '15%', left: '-20px', width: '160px', height: '160px', borderRadius: '50%', border: '2px dashed var(--v2)', opacity: 0.2 }} />

    
    <div style={{ position: 'absolute', top: '15%', right: '-30px', width: '140px', height: '140px', borderRadius: '50%', border: '4px solid var(--v1)', opacity: 0.2 }} />
    <div style={{ position: 'absolute', top: '40%', right: '50px', width: '60px', height: '60px', borderRadius: '50%', background: 'var(--v2)', opacity: 0.15 }} />
    <div style={{ position: 'absolute', top: '25%', right: '120px', width: '25px', height: '25px', borderRadius: '50%', background: 'var(--v1)', opacity: 0.25 }} />
    <div style={{ position: 'absolute', bottom: '20%', right: '-10px', width: '90px', height: '90px', borderRadius: '50%', border: '2px solid var(--v2)', opacity: 0.25 }} />
  </div>
);

const Microinternships = () => {

  const navigate = useNavigate();
  const { user } = useAuth();

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [formData, setFormData] = useState({
    name: '', email: '', college: '', year: '1st', transactionId: ''
  });
  const [screenshot, setScreenshot] = useState(null);
  const [upiCopied, setUpiCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [adminEnrolling, setAdminEnrolling] = useState(null); // course id currently bypassing payment
  const [pricing, setPricing] = useState({});

  useEffect(() => {
    API.get('/card-pricing').then(r => setPricing(r.data)).catch(() => {});
  }, []);

  const coursesWithPricing = MICRO_COURSES.map(course => {
    const override = pricing[`micro-${course.id}`];
    return {
      ...course,
      oldPrice: override?.oldPrice ?? null,
      newPrice: override?.newPrice ?? course.defaultPrice,
    };
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleFileChange = (e) => setScreenshot(e.target.files[0]);

  // Admins skip the payment step entirely and go straight to the task page.
  const adminInstantAccess = async (course) => {
    setAdminEnrolling(course.id);
    try {
      const res = await API.post('/microinternships/admin-enroll', { courseName: course.title });
      navigate(`/microinternship-task/${res.data.internshipId}?email=${encodeURIComponent(user.email)}`);
    } catch (err) {
      console.error(err);
      setAdminEnrolling(null);
    }
  };

  const openCourse = (course) => {
    if (user?.role === 'admin') { adminInstantAccess(course); return; }
    if (user) {
      setFormData(f => ({ ...f, name: f.name || user.name || '', email: f.email || user.email || '' }));
    }
    setSelectedCourse(course);
  };

  const closeModal = () => {
    if (!loading) { setSelectedCourse(null); setError(null); }
  };

  const goToLogin = () => navigate('/login', { state: { from: '/microinternships' } });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) { setError('Please login or sign up to continue.'); return; }
    if (!screenshot) { setError('Please upload the payment screenshot.'); return; }
    setLoading(true); setError(null);
    try {
      const data = new FormData();
      Object.keys(formData).forEach(key => data.append(key, formData[key]));
      data.append('courseName', selectedCourse.title);
      data.append('paymentScreenshot', screenshot);

      const res = await API.post('/microinternships/enroll', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      navigate(`/microinternship-task/${res.data.internshipId}?email=${formData.email}`);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '14px 16px', marginBottom: 16,
    background: 'var(--bg2)', border: '1px solid var(--border)',
    borderRadius: 8, color: 'var(--text)', fontSize: 14,
    outline: 'none', transition: 'border 0.2s', fontFamily: "inherit"
  };

  return (
    <>
      <style>{`
        .micro-page {
          background: var(--bg);
          
          color: var(--text);
          min-height: 100vh;
          font-family: 'Satoshi', 'Inter', system-ui, sans-serif;
          padding-bottom: 100px;
        }
        .hero-section {
          text-align: center;
          padding: 100px 20px 60px;
        }
        .hero-title {
          font-family: 'Inter', sans-serif;
          font-size: clamp(36px, 5vw, 64px);
          font-weight: 800;
          letter-spacing: -0.02em;
          margin-bottom: 24px;
          line-height: 1.1;
        }
        .hero-title span {
          background: var(--grad-brand);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .hero-subtitle {
          font-size: clamp(16px, 2vw, 18px);
          color: var(--text-2);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }
        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 32px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        .micro-card {
          background: var(--card);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          overflow: hidden;
          color: var(--text);
          cursor: pointer;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease;
          display: flex;
          flex-direction: column;
          position: relative;
        }
        .micro-card:hover:not(.card-coming-soon) {
          transform: translateY(-8px);
          box-shadow: var(--shadow-hover); border: 1px solid var(--border-strong);
        }
        .card-coming-soon {
          cursor: default;
          opacity: 0.55;
          filter: grayscale(0.4);
        }
        .cs-badge {
          position: absolute;
          top: 14px;
          left: 14px;
          background: rgba(0,0,0,0.75);
          backdrop-filter: blur(6px);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          padding: 4px 12px;
          border-radius: 999px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          border: 1px solid rgba(255,255,255,0.12);
          z-index: 2;
        }
        .card-img-wrapper {
          width: 100%;
          height: 220px;
          overflow: hidden;
        }
        .card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }
        .micro-card:hover:not(.card-coming-soon) .card-img {
          transform: scale(1.05);
        }
        .card-content {
          padding: 24px;
          display: flex;
          flex-direction: column;
          flex: 1;
        }
        .card-title {
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          line-height: 1.3;
        }
        .card-desc {
          color: var(--muted);
          font-size: 14.5px;
          line-height: 1.6;
          margin-bottom: 24px;
          flex: 1;
        }
        .card-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 16px;
          border-top: 1px solid var(--border);
        }
        .card-price {
          font-family: 'Inter', sans-serif;
          font-size: 24px;
          font-weight: 800;
        }
        .card-btn {
          background: var(--bg);
          color: var(--text);
          padding: 8px 20px;
          border-radius: 99px;
          font-size: 14px;
          font-weight: 600;
          transition: background 0.2s;
        }
        .micro-card:hover:not(.card-coming-soon) .card-btn {
          background: var(--v2);
        }
        .card-btn-cs {
          background: var(--bg3);
          color: var(--muted);
          padding: 8px 20px;
          border-radius: 99px;
          font-size: 13px;
          font-weight: 600;
        }
        
        /* Modal Animations */
        .modal-overlay {
          animation: fadeIn 0.3s ease-out forwards;
          position: fixed; inset: 0; z-index: 5000;
          background: rgba(0,0,0,0.7);
          backdrop-filter: blur(8px);
          display: flex; align-items: center; justify-content: center;
          padding: 20px;
        }
        .modal-content {
          animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          background: var(--card);
          backdrop-filter: blur(12px);
          border-radius: 24px;
          width: 100%; max-width: 960px;
          max-height: 90vh; overflow: hidden;
          display: flex; flex-direction: column;
          color: var(--text);
          box-shadow: var(--shadow-lg);
          position: relative;
        }
        .login-banner {
          display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;
          background: linear-gradient(135deg, rgba(127,0,255,0.14), rgba(177,99,255,0.09));
          border-bottom: 1px solid var(--border);
          padding: 16px 56px 16px 24px; flex-shrink: 0;
        }
        .login-banner-text { font-size: 14px; font-weight: 600; color: var(--text); }
        .login-banner-btn {
          background: var(--v1); color: #fff; border: none; padding: 10px 20px; border-radius: 8px;
          font-weight: 700; font-size: 13.5px; cursor: pointer; white-space: nowrap;
          font-family: inherit; transition: opacity 0.2s;
        }
        .login-banner-btn:hover { opacity: 0.88; }
        .modal-columns { display: flex; flex: 1; min-height: 0; }
        .modal-left {
          width: 45%;
          background: var(--bg2);
          padding: 40px;
          border-right: 1px solid var(--border);
          display: flex; flex-direction: column;
          overflow-y: auto;
        }
        .modal-right {
          width: 55%;
          padding: 40px;
          overflow-y: auto;
        }
        .modal-course-img { width: 100%; height: 180px; object-fit: cover; border-radius: 12px; margin-bottom: 24px; }

        @media (max-width: 768px) {
          .modal-overlay { padding: 0; align-items: flex-end; }
          .modal-content { max-height: 96vh; border-radius: 24px 24px 0 0; }
          .login-banner { padding: 14px 50px 14px 16px; }
          .login-banner-text { font-size: 13px; }
          .modal-columns { flex-direction: column; overflow-y: auto; }
          .modal-left, .modal-right { width: 100% !important; padding: 24px !important; }
          .modal-left { border-right: none !important; border-bottom: 1px solid var(--border); }
          .modal-course-img { height: 130px; margin-bottom: 16px; }
        }
        .close-btn {
          position: absolute; top: 20px; right: 20px;
          background: var(--bg3); border: none;
          width: 36px; height: 36px; border-radius: 50%;
          color: var(--text); font-size: 16px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          z-index: 10; transition: background 0.2s;
        }
        .close-btn:hover { background: var(--bg4); }

        .qr-box {
          background: var(--card-solid); border: 1px solid var(--border);
          padding: 20px; border-radius: 16px; margin-bottom: 16px;
          display: flex; flex-direction: column; align-items: center; gap: 14px;
          width: 100%; max-width: 260px;
        }
        .qr-img {
          width: 100%; max-width: 200px; aspect-ratio: 1 / 1; object-fit: contain;
          border-radius: 10px; border: 1px solid var(--border); background: #fff; padding: 8px;
        }
        .upi-tag {
          display: flex; flex-direction: column; align-items: center; gap: 3px;
          background: rgba(127,0,255,0.08); border: 1px solid rgba(127,0,255,0.25);
          padding: 9px 16px; border-radius: 999px; width: 100%;
          cursor: pointer; font-family: inherit; transition: background 0.2s, border-color 0.2s;
        }
        .upi-tag:hover { background: rgba(127,0,255,0.14); border-color: rgba(127,0,255,0.4); }
        .upi-tag-label { font-size: 10px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--muted); }
        .upi-tag-value { font-size: 13.5px; font-weight: 700; color: var(--v2); word-break: break-all; }
        .contact-note { font-size: 13px; color: var(--muted); margin-bottom: 8px; }
        .contact-note a { color: var(--v2); font-weight: 700; text-decoration: none; }
        .contact-note a:hover { text-decoration: underline; }
        @media (max-width: 768px) {
          .qr-box { max-width: 100%; }
        }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { 
          from { opacity: 0; transform: translateY(40px) scale(0.98); } 
          to { opacity: 1; transform: translateY(0) scale(1); } 
        }
      `}</style>


      <Seo
        title="₹99 Micro-Internships"
        description="Get real hands-on experience and a verified certificate for just ₹99. ThiranX's micro-internships are short, task-based, and built for students to build a portfolio fast."
        path="/microinternships"
      />
      <div className="micro-page">
        <section className="hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
          <DecorativeBubbles />
          <div style={{ position: 'relative', zIndex: 2 }}>

          <h1 className="hero-title">
            The ₹99 <span>Microinternship</span>
          </h1>
          <p className="hero-subtitle">
            Complete real-world tasks, get your code reviewed by industry experts, and earn a verified certificate for just ₹99.
          </p>
          </div>
        </section>

        <section className="cards-grid">
          {coursesWithPricing.map(course => (
            <div
              key={course.id}
              className={`micro-card ${course.comingSoon ? 'card-coming-soon' : ''}`}
              onClick={() => !course.comingSoon && !adminEnrolling && openCourse(course)}
              style={adminEnrolling === course.id ? { opacity: 0.6, cursor: 'wait' } : undefined}
            >
              {course.comingSoon && <span className="cs-badge">Coming Soon</span>}
              <div className="card-img-wrapper">
                <img src={course.image} alt={course.title} className="card-img" />
              </div>
              <div className="card-content">
                <h3 className="card-title">{course.title}</h3>
                <p className="card-desc">{course.desc}</p>
                <div className="card-footer">
                  {course.comingSoon
                    ? <span className="card-price">—</span>
                    : <PriceTag oldPrice={course.oldPrice} newPrice={course.newPrice} className="card-price" oldSize={13} />
                  }
                  {course.comingSoon
                    ? <span className="card-btn-cs">Coming Soon</span>
                    : <span className="card-btn">{adminEnrolling === course.id ? 'Opening…' : (user?.role === 'admin' ? 'Open (Admin)' : 'Enroll Now')}</span>
                  }
                </div>
              </div>
            </div>
          ))}
        </section>

        {selectedCourse && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="close-btn" onClick={closeModal}>✕</button>

              {!user && (
                <div className="login-banner">
                  <span className="login-banner-text">🔒 Please login or sign up to enroll in this microinternship.</span>
                  <button type="button" className="login-banner-btn" onClick={goToLogin}>Login / Sign Up →</button>
                </div>
              )}

              <div className="modal-columns">
              <div className="modal-left">
                <img src={selectedCourse.image} alt={selectedCourse.title} className="modal-course-img" />
                <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12 }}>{selectedCourse.title}</h2>
                <p style={{ color: 'var(--muted)', fontSize: 15, marginBottom: 32, lineHeight: 1.6 }}>{selectedCourse.desc}</p>
                
                <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Step 1: Pay ₹{selectedCourse.newPrice}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 20 }}>Scan the QR code below and save the payment screenshot.</p>

                <div className="qr-box">
                  <img src={upiQr} alt="UPI QR Code" className="qr-img" />
                  <button
                    type="button"
                    className="upi-tag"
                    onClick={() => {
                      navigator.clipboard.writeText('yeeswanthlatha-1@okaxis');
                      setUpiCopied(true);
                      setTimeout(() => setUpiCopied(false), 1800);
                    }}
                  >
                    <span className="upi-tag-label">UPI ID {upiCopied ? '· Copied!' : '· Tap to Copy'}</span>
                    <span className="upi-tag-value">yeeswanthlatha-1@okaxis</span>
                  </button>
                </div>

                <p className="contact-note">
                  Any doubts? Call / WhatsApp <a href="tel:6381253611">6381253611</a>
                </p>
              </div>

              <div className="modal-right">
                <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24 }}>Step 2: Submit Details</h3>
                
                {error && <div style={{ background: '#FEE2E2', color: '#DC2626', padding: '12px 16px', borderRadius: 8, marginBottom: 24, fontSize: 14, fontWeight: 500 }}>{error}</div>}

                <form onSubmit={handleSubmit}>
                <fieldset disabled={!user || loading} style={{ border: 'none', padding: 0, margin: 0, opacity: !user ? 0.5 : 1 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Full Name</label>
                  <input type="text" name="name" required placeholder="Your Name" value={formData.name} onChange={handleChange} style={inputStyle} />

                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Email Address</label>
                  <input type="email" name="email" required placeholder="name@example.com" value={formData.email} onChange={handleChange} style={inputStyle} />

                  <div style={{ display: 'flex', gap: 16 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>College Name</label>
                      <input type="text" name="college" required placeholder="University/College Name" value={formData.college} onChange={handleChange} style={inputStyle} />
                    </div>
                    <div style={{ width: 120 }}>
                      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Year</label>
                      <select name="year" value={formData.year} onChange={handleChange} style={{ ...inputStyle, padding: '13px 16px' }}>
                        <option value="1st">1st Year</option>
                        <option value="2nd">2nd Year</option>
                        <option value="3rd">3rd Year</option>
                        <option value="4th">4th Year</option>
                        <option value="Passout">Passout</option>
                      </select>
                    </div>
                  </div>

                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>UPI Transaction ID / UTR</label>
                  <input type="text" name="transactionId" required placeholder="e.g., 312345678901" value={formData.transactionId} onChange={handleChange} style={inputStyle} />

                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#374151' }}>Payment Screenshot</label>
                  <input type="file" accept="image/*" required onChange={handleFileChange} style={{ ...inputStyle, padding: '10px 16px', background: 'transparent' }} />

                  <button type="submit" disabled={loading || !user} style={{
                    width: '100%', padding: '16px', marginTop: 8,
                    background: 'var(--v1)', color: '#FFF', border: 'none', borderRadius: 8,
                    fontSize: 15, fontWeight: 600, cursor: (loading || !user) ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.7 : 1, transition: 'background 0.2s'
                  }}>
                    {loading ? 'Submitting...' : !user ? 'Login Required to Enroll' : 'Submit & Enroll'}
                  </button>
                </fieldset>
                </form>
              </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Microinternships;
